import { io } from "socket.io-client";

// "undefined" means the URL will be computed from the `window.location` object
const URL = undefined;
// const URL = "http://localhost:8983";
export const socket = io(URL, { transports: ["websocket"] });
